import { createNamespace, addUnit } from '../utils';

var _createNamespace = createNamespace('file-icon'),
    createComponent = _createNamespace[0];

export default createComponent({
  props: {
    name: String,
    size: [Number, String]
  },
  methods: {
    defaultIcon: function defaultIcon() {
      switch (this.name) {
        case 'doc':
          return 'http://mui.ucmed.cn/images/icon/doc.png';

        case 'eps':
          return 'http://mui.ucmed.cn/images/icon/eps.png';

        case 'jpg':
          return 'http://mui.ucmed.cn/images/icon/jpg.png';

        case 'mp4':
          return 'http://mui.ucmed.cn/images/icon/mp4.png';

        case 'pdf':
          return 'http://mui.ucmed.cn/images/icon/pdf.png';

        case 'png':
          return 'http://mui.ucmed.cn/images/icon/png.png';

        case 'ppt':
          return 'http://mui.ucmed.cn/images/icon/ppt.png';

        case 'psd':
          return 'http://mui.ucmed.cn/images/icon/psd.png';

        case 'qa':
          return 'http://mui.ucmed.cn/images/icon/qa.png';

        case 'rep':
          return 'http://mui.ucmed.cn/images/icon/rep.png';

        case 'xls':
          return 'http://mui.ucmed.cn/images/icon/xls.png';

        case 'zip':
          return 'http://mui.ucmed.cn/images/icon/zip.png';
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var size = this.size;
    var contentStyle = {
      width: addUnit(size)
    };
    return h("div", {
      "attrs": {
        "role": "fileIcon"
      }
    }, [h("img", {
      "attrs": {
        "src": this.defaultIcon()
      },
      "style": contentStyle
    })]);
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant-green/es/file-icon/index.js
// module id = null
// module chunks = 